import BalanceCard from '@/basecomponents/cards/BalanceCard';

import BaseDefinitionList from '@/basecomponents/datagroup/BaseDefinitionList';

import BaseAutocompleteEmptyField from '@/basecomponents/form/BaseAutocompleteEmptyField';
import BaseChipSelectField from '@/basecomponents/form/BaseChipSelectField';
import BaseCurrencySelectField from '@/basecomponents/form/BaseCurrencySelectField';
import BaseCurrencySelectDynamicField from '@/basecomponents/form/BaseCurrencySelectDynamicField';
import BaseDatePicker from '@/basecomponents/form/BaseDatePicker';
import BaseDatePickerRange from '@/basecomponents/form/BaseDatePickerRange';
import BaseDynamicField from '@/basecomponents/form/BaseDynamicField';
import BaseDynamicLevel from '@/basecomponents/form/BaseDynamicLevel';
import BaseFieldsGenerator from '@/basecomponents/form/BaseFieldsGenerator';
import BaseFloatField from '@/basecomponents/form/BaseFloatField';
import BaseCurrencyInputField from '@/basecomponents/form/BaseCurrencyInputField';
import BaseCurrencyInputDynamicField from '@/basecomponents/form/BaseCurrencyInputDynamicField';
import BaseInvoiceItemsField from '@/basecomponents/form/BaseInvoiceItemsField';
import BasePhoneField from '@/basecomponents/form/BasePhoneField';
import BasePasswordField from '@/basecomponents/form/BasePasswordField';
import BaseSelectField from '@/basecomponents/form/BaseSelectField';
import BaseTextField from '@/basecomponents/form/BaseTextField';
import BaseTextAreaField from '@/basecomponents/form/BaseTextAreaField';
import BaseTimePicker from '@/basecomponents/form/BaseTimePicker';

import BaseConfirmDialog from '@/basecomponents/dialogs/BaseConfirmDialog';
import BaseDialog from '@/basecomponents/dialogs/BaseDialog';
import BaseDetailDialog from '@/basecomponents/dialogs/BaseDetailDialog';

export const BaseComponents = {
  BalanceCard,
  BaseDefinitionList,
  BaseAutocompleteEmptyField,
  BaseChipSelectField,
  BaseCurrencySelectField,
  BaseCurrencySelectDynamicField,
  BaseDatePicker,
  BaseDatePickerRange,
  BaseDynamicField,
  BaseDynamicLevel,
  BaseFieldsGenerator,
  BaseFloatField,
  BaseCurrencyInputField,
  BaseCurrencyInputDynamicField,
  BaseInvoiceItemsField,
  BasePasswordField,
  BasePhoneField,
  BaseSelectField,
  BaseTextField,
  BaseTextAreaField,
  BaseTimePicker,
  BaseConfirmDialog,
  BaseDialog,
  BaseDetailDialog,
};